// eslint-disable-next-line no-shadow
export enum Direction {
	Top = `top`,
	Left = `left`,
	Bottom = `bottom`,
	Right = `right`
}